import Reveal from "./Reveal";
import SectionHeader from "./SectionHeader";
import { useLanguage } from "../context/LanguageContext";

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-sand py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeader eyebrow={t.steps.eyebrow} heading={t.steps.heading} />

        <div className="mt-16">
          {t.steps.items.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.08}>
              <div
                data-testid={`step-${step.number}`}
                className="group grid items-center gap-6 border-t border-line py-10 transition-colors duration-500 last:border-b hover:bg-white/50 md:grid-cols-12 md:gap-10 md:py-14"
              >
                <span className="chapter-number font-head text-7xl leading-none md:col-span-3 md:text-8xl">
                  {step.number}
                </span>
                <h3 className="font-head text-2xl text-ink transition-colors duration-300 group-hover:text-bronze-dark md:col-span-4 md:text-3xl">
                  {step.title}
                </h3>
                <p className="text-sm md:col-span-5 md:text-base leading-relaxed text-taupe">
                  {step.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
